var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.395,
    height: 17.001,
    viewBox: "0 0 17.395 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-5.411 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112149",
    "data-name": "Group 112149",
    transform: "translate(5.411 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M21.258,54.149v2.045A1.716,1.716,0,0,1,19.5,57.863H18.385a1.725,1.725,0,0,1-1.772-1.669V54.142H11.6v2.052a1.725,1.725,0,0,1-1.772,1.669H8.721a1.716,1.716,0,0,1-1.761-1.669V54.149a1.561,1.561,0,0,0-1.548,1.514V67.646A1.564,1.564,0,0,0,7.006,69.17H21.212a1.565,1.565,0,0,0,1.595-1.524V55.663A1.561,1.561,0,0,0,21.258,54.149ZM20.742,66.9a.673.673,0,0,1-.689.655H8.134a.673.673,0,0,1-.689-.655V60.71a.673.673,0,0,1,.689-.655H20.052a.673.673,0,0,1,.689.655V66.9Z",
    transform: "translate(-5.411 -52.169)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M80.154,0h1.1a.6.6,0,0,1,.6.6V4.132a.6.6,0,0,1-.6.6h-1.1a.6.6,0,0,1-.6-.6V.6A.6.6,0,0,1,80.154,0Z",
    transform: "translate(-76.848)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M345.062,0h1.1a.6.6,0,0,1,.6.6V4.132a.6.6,0,0,1-.6.6h-1.1a.6.6,0,0,1-.6-.6V.6A.6.6,0,0,1,345.062,0Z",
    transform: "translate(-332.102)",
    fill: "#2d5794"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d06f639deee98b5905143909e770d58.svg";
export { ForwardRef as ReactComponent };